(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-simple-slider"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const instances = new Map();
    function initialize(root) {
      if (instances.has(root)) return;
      const slides = Array.from(root.querySelectorAll('[data-slide]'));
      if (!slides.length) return;
      const dots = root.querySelectorAll('[data-dot]');
      let current = 0;
      let timer;
      let selected = false;
      let pageLoaded = document.readyState === 'complete';
      const controller = new AbortController();
      const options = { signal: controller.signal };
      function loadSlide(index) {
        const template = slides[index % slides.length].querySelector('[data-slide-media]');
        if (!template) return;
        const content = template.content.cloneNode(true);
        content.querySelector('img').loading = 'eager';
        template.replaceWith(content);
      }
      function setActive(index) {
        current = (index + slides.length) % slides.length;
        loadSlide(current);
        if (pageLoaded) loadSlide(current + 1);
        slides.forEach((slide, i) => {
          slide.classList.toggle('is-active', i === current);
          slide.inert = i !== current;
          slide.setAttribute('aria-hidden', String(i !== current));
        });
        dots.forEach((dot, i) => {
          dot.classList.toggle('is-active', i === current);
          dot.setAttribute('aria-selected', String(i === current));
        });
      }
      function stop() { window.clearInterval(timer); }
      function start() {
        stop();
        if (slides.length > 1 && !selected && !window.Shopify?.designMode) {
          timer = window.setInterval(() => setActive(current + 1), 4500);
        }
      }
      root.querySelector('[data-next]')?.addEventListener('click', () => {
        setActive(current + 1); start();
      }, options);
      root.querySelector('[data-prev]')?.addEventListener('click', () => {
        setActive(current - 1); start();
      }, options);
      dots.forEach((dot, index) => dot.addEventListener('click', () => {
        setActive(index); start();
      }, options));
      root.addEventListener('shopify:block:select', (event) => {
        const index = slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
        if (index < 0) return;
        selected = true;
        stop();
        setActive(index);
      }, options);
      root.addEventListener('shopify:block:deselect', () => {
        selected = false; start();
      }, options);
      instances.set(root, () => { stop(); controller.abort(); });
      setActive(0);
      if (!pageLoaded) {
        window.addEventListener('load', () => {
          pageLoaded = true;
          loadSlide(current + 1);
        }, { ...options, once: true });
      }
      start();
    }
    function scan(container) {
      container.querySelectorAll('.hero-simple-slider').forEach(initialize);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => scan(document), { once: true });
    } else {
      scan(document);
    }
    document.addEventListener('shopify:section:load', event => scan(event.target));
    document.addEventListener('shopify:section:unload', event => {
      event.target.querySelectorAll('.hero-simple-slider').forEach(root => {
        instances.get(root)?.();
        instances.delete(root);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slider"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const instances = new Map();
    function initialize(root) {
      if (instances.has(root)) return;
      const slides = Array.from(root.querySelectorAll('[data-slide]'));
      if (!slides.length) return;
      const dots = root.querySelectorAll('[data-dot]');
      let current = 0;
      let timer;
      let selected = false;
      const controller = new AbortController();
      const options = { signal: controller.signal };
      function setActive(index) {
        current = (index + slides.length) % slides.length;
        slides.forEach((slide, i) => {
          slide.classList.toggle('is-active', i === current);
          slide.inert = i !== current;
          slide.setAttribute('aria-hidden', String(i !== current));
        });
        dots.forEach((dot, i) => {
          dot.classList.toggle('is-active', i === current);
          dot.setAttribute('aria-selected', String(i === current));
        });
      }
      function stop() { window.clearInterval(timer); }
      function start() {
        stop();
        if (slides.length > 1 && !selected && !window.Shopify?.designMode) {
          timer = window.setInterval(() => setActive(current + 1), 4500);
        }
      }
      root.querySelector('[data-next]')?.addEventListener('click', () => {
        setActive(current + 1); start();
      }, options);
      root.querySelector('[data-prev]')?.addEventListener('click', () => {
        setActive(current - 1); start();
      }, options);
      dots.forEach((dot, index) => dot.addEventListener('click', () => {
        setActive(index); start();
      }, options));
      root.addEventListener('shopify:block:select', (event) => {
        const index = slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
        if (index < 0) return;
        selected = true;
        stop();
        setActive(index);
      }, options);
      root.addEventListener('shopify:block:deselect', () => {
        selected = false; start();
      }, options);
      instances.set(root, () => { stop(); controller.abort(); });
      setActive(0);
      start();
    }
    function scan(container) {
      container.querySelectorAll('.hero-svg-slider').forEach(initialize);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => scan(document), { once: true });
    } else {
      scan(document);
    }
    document.addEventListener('shopify:section:load', event => scan(event.target));
    document.addEventListener('shopify:section:unload', event => {
      event.target.querySelectorAll('.hero-svg-slider').forEach(root => {
        instances.get(root)?.();
        instances.delete(root);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
